import { forwardRef, type ReactNode } from 'react'
import clsx from 'clsx'
import styles from './button.module.css'
import { createRipple } from '../utils'

type Props = {
  label: string
  icon?: ReactNode
  variant?: 'solid' | 'outlined'
  tone?: 'primary' | 'secondary'
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export const PrimaryButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      label,
      icon,
      className,
      style,
      variant = 'solid',
      tone = 'primary',
      ...rest
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        className={clsx(
          styles.root,
          styles[variant],
          styles[tone],
          !!className && className,
        )}
        style={style}
        onMouseDown={e => createRipple(e, styles.ripple)}
        onClick={() => {}}
        {...rest}
      >
        <div className={styles.icon}>{icon}</div>
        <span className={styles.label}>{label}</span>
      </button>
    )
  },
)

PrimaryButton.displayName = 'PrimaryButton'
